import apiClient from "./axios";

// Get all movement types with optional filtering
export const getMovementTypes = async (params = {}) => {
  const { data } = await apiClient.get("/movement-types", { params });
  return data;
};

// Get a specific movement type by ID
export const getMovementType = async (id) => {
  const { data } = await apiClient.get(`/movement-types/${id}`);
  return data;
};

// Get movement type by slug
export const getMovementTypeBySlug = async (slug) => {
  const { data } = await apiClient.get(`/movement-types/slug/${slug}`);
  return data;
};

// Create a new movement type
export const createMovementType = async (movementTypeData) => {
  const { data } = await apiClient.post("/movement-types", movementTypeData);
  return data;
};

// Update an existing movement type
export const editMovementType = async ({ id, ...movementTypeData }) => {
  const { data } = await apiClient.patch(`/movement-types/${id}`, movementTypeData);
  return data;
};

// Delete a movement type (soft delete)
export const deleteMovementType = async (id) => {
  const { data } = await apiClient.delete(`/movement-types/${id}`);
  return data;
};

// Get all movement types without pagination
export const getAllMovementTypes = async (params = {}) => {
  const { data } = await apiClient.get("/movement-types", { 
    params: { ...params, all: true } 
  });
  return data;
};

// Search movement types by name
export const searchMovementTypes = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/movement-types", { 
    params: { ...params, search: searchTerm } 
  });
  return data;
};

// Get trashed movement types
export const getTrashedMovementTypes = async (params = {}) => {
  const { data } = await apiClient.get("/movement-types/trashed", { params });
  return data;
};

// Restore a trashed movement type
export const restoreMovementType = async (id) => {
  const { data } = await apiClient.post(`/movement-types/${id}/restore`);
  return data;
};
